<template>
  <div id="pdfPage" ref="pdfPage">
    <b-button-group class="btnGroup">
      <b-button id="btnBack" class="buttons" @click="goBack">
        Back
      </b-button>
      <b-button id="btnExternal" class="buttons" @click="externalWindow">
        External
      </b-button>
      <!-- <b-button id="btnPrint" class="buttons" @click="printPDF">
        Print
      </b-button> -->
    </b-button-group>
    <object :data="pdfURL" :width="pdfWidth" :height="pdfHeight" type="application/pdf">
      <p>This device doesn't support embedded Documents.<br />
        Click <a :href="pdfURL" target="_blank">HERE</a> to view it.</p>
    </object>
    <!-- <pdf :src="pdfURL"></pdf> -->
  </div>
</template>

<script>
// import { VueEditor } from 'vue2-editor';
import pdf from 'vue-pdf';

// import pdf from 'pdfvuer';
// eslint-disable-next-line
import utl from '../myUtils';

export default {
  components: {
    pdf,
  },
  name: 'showPDF',
  data() {
    return {
      // pdfWidth: 400,
      // pdfHeight: 800,
    };
  },
  watch: {
  },
  computed: {
    pdfHeight() {
      return this.$store.getters.getCliHeight;
    },
    pdfWidth() {
      return this.$store.getters.getCliWidth;
    },
    fonts() {
      return this.$store.getters.getFonts;
    },
    cun() {
      return this.$store.getters.getCuNumber;
    },
    member() {
      return this.$store.getters.getMember;
    },
    siFormUser() {
      return this.$store.getters.getSiFormUser;
    },
    navVer() {
      return this.$store.getters.getNavVer;
    },
    statements() {
      return this.$store.getters.getStatements;
    },
    stateCC() {
      return this.$store.getters.getSTcc;
    },
    webPageResponse() {
      return this.$store.getters.webPageResponse;
    },
    pdfURL() {
      return this.$store.getters.getPdfUrl;
    },
  },
  methods: {
    goBack() {
      window.history.back();
    },
    printPDF() {
      // this.$htmlToPaper('pdfBox');
    },
    externalWindow() {
      const newTab = window.open();
      newTab.location.href = this.pdfURL;
    },
  },
  mounted() {
    //
  },
};
</script>

<style scoped>
.btnGroup {
  position: relative;
  width: 100%;
  height: 36px;
}
.buttons {
  position: absolute;
  top: 4px;
  height: 25px;
  width: 75px;
  padding: 0px;
}
#btnBack {
  left: 4px;
  background-color: red;
  color: black;
}
#btnExternal {
  left: 84px;
  background-color: lime;
  color: black;
}
#btnPrint {
  left: 162px;
  background-color: lime;
  color: black;
}
#pdfBox {
  border: solid 1px black;
}
</style>



// WEBPACK FOOTER //
// src/components/showPDF.vue